import { ApiRequest } from "../../Common";
import { endpoints } from "../Constants/endpoints";

// eslint-disable-next-line consistent-return
export const setFeedbackAssignedUsers = async (feedbackCode: string, userIds: number[]) => {
  const response = await ApiRequest.fromPath(
    endpoints.feedback.assignment.assignments(feedbackCode)
  )
    .withAuthHeader()
    .withJson({ userIds })
    .put();
  if (response.ok) {
    return;
  }
  if (!response.ok) {
    console.log(response);
    throw new Error(`${await response.text()}`);
  }
};
